import React from 'react';
import { Col, Row, Container } from 'reactstrap';
import { form, group, inputs, title, formFieldWrap, formFieldWrapTextareaWrap } from './FormView.module.css';
import { imgUrlGenerate, getNoSymbsLowerCaseStr } from '../../helpers';
import Button from '../UI/Button';
import Image from '../UI/Image';
import Auxiliary from '../../hoc/Auxiliary';
import InputElement from 'react-input-mask';
import { NAME, EMAIL, PHONE } from '../../utils/constants';
import Loader from '../UI/Loader';
import Input from '../UI/Input';
import { bool, string, func, number } from 'prop-types';

const FormView = ({
  name, phone,
  nameNotValid, emailNotValid, orderMessageNotValid,
  validEmail, validOrderMessage, validName, deniedSubmissionsCounter,
  submitHandler, onValueChange,
  loading,
}) => (
    <>
      {loading ? <Loader /> :
        (<section className="contact-us">
          <Container>
            <Row>
              <Col lg={{ size: 8, offset: 2 }}>
                <div className="title">
                  Tell us about your tastes
                </div>
                <Image className="beans-logo" src={imgUrlGenerate(`Beans_logo_dark.svg`)} alt="Beans Logo" />

                <form className={form} onSubmit={submitHandler}>
                  <div className={inputs}>
                    {[NAME, EMAIL, PHONE].map((labelText, index) => {
                      return (
                        <Auxiliary key={`${labelText}-${index}`}>
                          {labelText === PHONE ?
                            (<div className={group} key={`${labelText}-${index}`}>
                              <label htmlFor={getNoSymbsLowerCaseStr(labelText)}>
                                {labelText}
                              </label>
                              <InputElement
                                id={getNoSymbsLowerCaseStr(labelText)}
                                name={getNoSymbsLowerCaseStr(labelText)}
                                type="tel"
                                mask="+380(99) 999-99-99"
                                onChange={onValueChange}
                                placeholder="+380(__) ___-__-__"
                                value={phone}
                              />
                            </div>) :
                            labelText === NAME ?
                              (<Input
                                id={getNoSymbsLowerCaseStr(labelText)}
                                name={getNoSymbsLowerCaseStr(labelText)}
                                label={labelText}
                                type="text"
                                onChange={onValueChange}
                                value={name}
                                inputWrapperStyles={formFieldWrap}
                                error={(deniedSubmissionsCounter && !validName) ? nameNotValid : null}
                                isRequired
                              />)
                              :
                              (<Input
                                id={getNoSymbsLowerCaseStr(labelText)}
                                name={getNoSymbsLowerCaseStr(labelText)}
                                label={labelText}
                                type="text"
                                onChange={onValueChange}
                                inputWrapperStyles={formFieldWrap}
                                error={(deniedSubmissionsCounter && !validEmail) ? emailNotValid : null}
                                isRequired
                              />)
                          }
                        </Auxiliary>
                      )
                    })
                    }
                  </div>

                  <Input
                    isTextarea
                    name="orderMessage"
                    id="message"
                    placeholder="Leave your comments here"
                    onChange={onValueChange}
                    label="Your message"
                    labelStyles={title}
                    inputWrapperStyles={formFieldWrapTextareaWrap}
                    error={(deniedSubmissionsCounter && !validOrderMessage) ? orderMessageNotValid : null}
                    isRequired
                  />
                  <Button type="submit">Send</Button>
                </form>
              </Col>
            </Row>
          </Container>
        </section>)
      }
    </>
  )

FormView.propTypes = {
  name: string,
  phone: string,

  nameNotValid: string,
  emailNotValid: string,
  orderMessageNotValid: string,

  validEmail: bool,
  validOrderMessage: bool,
  validName: bool,
  deniedSubmissionsCounter: number,

  submitHandler: func,
  onValueChange: func,

  loading: bool,
}

FormView.defaultProps = {
  name: '',
  phone: '',

  nameNotValid: '',
  emailNotValid: '',
  orderMessageNotValid: '',

  validEmail: false,
  validOrderMessage: false,
  validName: false,
  deniedSubmissionsCounter: 0,

  submitHandler: () => { },
  onValueChange: () => { },

  loading: false,
}

export default FormView